import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";
import FirmList from "../../../firms/FirmList";
import { Link, useNavigate } from "react-router-dom";
import FirmSubUpdate from '../../../firms/FirmSubUpdate';
import FirmSubUserUpdate from '../../../firms/FirmSubUserUpdate';
import ThemeContext from "../../../../context/ThemeContext";
import UserContext from '../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';



import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../lang/LangGlb';
//theme
import "primereact/resources/themes/tailwind-light/theme.css";     
    
//core
import "primereact/resources/primereact.min.css";         



const GET_POST = gql`
query MyQuery($firmCode: String!) {
    tbl_firm_main_coop(where: {firm_main_code_n: {_eq: $firmCode}}) {
    own_firm_main_code
    own_firm_sub_code
    own_firm_sub_type
    firm_main_code_n
    firm_main_name_n
    firm_main_type_n
    int_ID
    create_user
    update_user
    created_at
    updated_at
  }
  tbl_firm_sub_coop(where: {firm_main_code_n: {_eq: $firmCode}}) {
    own_firm_main_code
    own_firm_sub_code
    own_firm_sub_type
    firm_main_code_n
    firm_sub_code_n
    firm_sub_name_n
    firm_sub_type_n
    int_ID
    create_user
    update_user
    created_at
    updated_at
    
  }
  tbl_user_detail(where: {firm_main_code: {_eq: $firmCode}}) {
    firm_main_code
    firm_sub_code
    user_name
    name
    last_name
    user_type
    dpr_main_code
    dpr_sub_code
    user_lang
    data_lang
    create_user
    update_user
    created_at
    updated_at
  }
}
`;

const UPDATE_FIRM = gql`
mutation UpdateFirm(
 
  $firmCode: String!
  $firmName: String!
  ) {
  update_tbl_firm_main_coop(
    where: { firm_main_code_n: { _eq: $firmCode } }
    _set: { firm_main_name_n: $firmName }
  ) {
    affected_rows
  }
}
`; 


const FirmDtl = () => {
  const { firm_main_code_n } = useParams();
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmCode: firm_main_code_n },
  });

  const navigate = useNavigate();

 

  
  const [updateFirm] = useMutation(UPDATE_FIRM);

  const firmData = data && data.tbl_firm_main_coop ? data.tbl_firm_main_coop[0] : null;
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
  const [firmName, setFirmName] = useState(firmData ? firmData.firm_main_name_n : "");
  const [firmType, setFirmType] = useState(firmData ? firmData.firm_main_type_n : "");
  const [place, setPlace] = useState(firmData ? firmData.place : "");
  const [fmActive, setFmActive] = useState(firmData ? firmData.active : true);
  const [activeTab, setActiveTab] = useState(1);

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);


  const lang = users.userLang;
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const close_form = messages[currentLocale].close_form;
  const new_firm = messages[currentLocale].new_firm;
  const search_by_firm_name = messages[currentLocale].search_by_firm_name;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const placerec = messages[currentLocale].placerec;
  const time_zone = messages[currentLocale].time_zone;
  const update_firm = messages[currentLocale].update_firm;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;
  const create = messages[currentLocale].create;
  const update = messages[currentLocale].update;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const definitions = messages[currentLocale].definitions;
  const managing_agency = messages[currentLocale].managing_agency;
  const firm_detail = messages[currentLocale].firm_detail;
  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard
  const firm_update_successfully = messages[currentLocale].firm_update_successfully;

  const firm_main_code_l = messages[currentLocale].firm_main_code_l;
  const firm_sub_code = messages[currentLocale].firm_sub_code;
  const firm_sub_name = messages[currentLocale].firm_sub_name;





  const handleOpenModal = (param) => {
    setModalParam(param);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    refetch();
    
  };

  const handleOpenModal2 = (param) => {
    setModalParam(param);
    setOpenModal(true);
  };

  const handleCloseModal2 = () => {
    setOpenModal(false);
    
  };

  useEffect(() => {
    if (firmData) {
    //   setFirmcode(firmData.firm_main_code_n);
      setFirmName(firmData.firm_main_name_n);
      setFirmType(firmData.firm_main_type_n);
      setPlace(firmData.place);
      setFmActive(firmData.active);
    }
  }, [firmData]);

  const handleUpdate = () => {
   
    
    updateFirm({
      variables: {
       
        firmCode: firmData.firm_main_code_n,
        firmName: firmName,
        
      },
    })
      .then(() => {
        window.alert(firm_update_successfully);
        refetch();
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-xs"
      : "text-gray-500 font-bold text-xs";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };

  const actionTemplate = (rowData) => {
    refetch();
    return (
      <Link to={`/htl/hotel-adm/firm/agencydtlsub-coop/${rowData.firm_sub_code_n}`}>
        <button
          type="button"
          title="Open details"
          className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
            <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z"></path>
          </svg>
        </button>
        
      </Link>
      
    );
      };

  const userAndCreatedAtTemplate = (rowData) => {
    const dateTimeString = rowData.created_at; //"2023-09-27T08:45:36.735838+00:00"
    
    const dateObj = new Date(dateTimeString);
    const tarih = dateObj.toLocaleDateString(); // Tarih
    const saat = dateObj.toLocaleTimeString(); // Saat
  
    return (
      <div>
        <div className="text-xs">Kullanıcı: {rowData.create_user}</div>
        <div className="text-xs">Tarih: {tarih}</div>
        <div className="text-xs">Saat: {saat}</div>
      </div>
    );
  };



  



  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (!firmData) {
    return <p>No firm data found.</p>;
  }
  const items = [{ label: dashboard ,url: "/", target: '_self'}, { label: definitions }, { label: administrator ,url:"/htl/hotel-adm/main" }, { label: managing_agency ,url:"/htl/hotel-adm/firm/agency-list-coop" }, { label: firm_detail }];

  return (

    

    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    <div className="flex justify-between items-center">
      <nav>
        <ul className="flex border-solid mt-3 rounded-md border-b outline-1 mb-5">
          {items.map((item, index) => (
            <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
              {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
              {item.url ? (
                <Link to={item.url}>{item.label}</Link>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          ))}
        </ul>
      </nav>
      <button onClick={() => navigate(-1)} className="flex text-violet-900 hover:text-violet-200 font-bold">
        {close_form}
      </button>
    </div>
  
  
   
   

      <div className="card min-h-[40em] ">
     
      <div className=" p-2 ">
          <div className="card pt-1 -ml-10 -my-10 font-medium"> 
            <Fieldset>
            <p className="my-0 font-medium ">

          <div className="flex gap-4">
          <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_code}</label>
    <InputText className="w-full" 
    id="username" value={firmData.firm_main_code_n}
    />
  </div>

  <div className="w-2/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{firm_name}</label>
    <InputText className="w-full" 
    id="firmname" value={firmName} 
    onChange={(e) => setFirmName(e.target.value)} />
  </div>
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_type}</label>
    <InputText className="w-full" 
    id="firmtype" 
    name="firmtype"
    value={firmType}
    onChange={(e) => setFirmType(e.target.value)}
    readOnly/>
  </div>
  </div>

  
  <div className="flex gap-3 my-5">
    
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_type}</label>
    <InputText className="w-full" 
    id="firmtype" 
    name="firmtype"
    value={firmType}
    onChange={(e) => setFirmType(e.target.value)}
    readOnly/>
  </div>

  

  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="place">{placerec}</label>
    <InputText className="w-full" 
    id="place" 
    name="place"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>

  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{time_zone}</label>
    <InputText className="w-full" 
    id="timezone" 
    name="timezone"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>

  <div className=" flex-col font-medium  flex justify-content-center">
  
  <label htmlFor="firmtype" 
  className=" flex-col  ml-0 mb-5 align-items-center block font-medium text-gray-950">{statusrec} </label><p></p>
  <div className="flex ml-0 flex-wrap gap-6">
  <div className="flex ml-0 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setFmActive(e.value)} checked={fmActive === true} />
          <label htmlFor="ingredient1" className="ml-2">{activerec}</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setFmActive(e.value)} checked={fmActive === false} />
          <label htmlFor="ingredient2" className="ml-2">{inactiverec}</label>
      </div>
      </div>
      </div>  
      </div>
      <div className="mt-0 ">
        <Button label={update_firm} aria-label="Update" 
          className=" p-button-sm p-button-outlined bg-purple-800 hover:bg-blue-600 text-white font-semibold  rounded-md"
          onClick={handleUpdate}  
        />
        </div>

</p>
         </Fieldset>
        </div>
        
   
        
             
        </div>          
     

      <p> <DataTable
         value={data.tbl_firm_sub_coop } responsiveLayout="scroll"

         
        
        >
           <Column field="firm_main_code_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{firm_code}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>
          <Column field="firm_sub_code_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{firm_sub_code}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>

          <Column field="firm_sub_name_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{firm_sub_name}</span>}
           style={{ textAlign: 'left', width: '20rem' }}
          >
          </Column>

          <Column field="firm_sub_type_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{firm_type}</span>}
           style={{ textAlign: 'center', width: '7rem' }}
          >
          </Column>   

         
          <Column field="place"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{placerec}</span>}
           style={{ textAlign: 'right', width: '6rem' }}
          >
          </Column>

          <Column field="ent_ID"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{int_id}</span>}
           style={{ textAlign: 'right', width: '6rem' }}
          >
          </Column>

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{statusrec}</span>}
            style={{ textAlign: 'left', width: '6rem' }}
            className="font-bold text-xs" 
          />
          <Column
           field="created_at"
           header={<span className="font-bold text-xs text-gray-900">{create}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.created_at;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} ${dateObj.toLocaleTimeString('en-GB')}`;
            const createUser = rowData.create_user;

          return (
           <div className="text-xs">
           {createUser} - {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'right', width: '6rem' }}
           />

<Column
           field="updated_at"
           header={<span className="font-bold text-xs text-gray-900">{update}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.updated_at;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} ${dateObj.toLocaleTimeString('en-GB')}`;
            const createUser = rowData.update_user;

          return (
           <div className="text-xs">
           {createUser} - {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'right', width: '6rem' }}
           />

<Column
            body={actionTemplate}
            header={<span className="font-bold text-gray-900">{detail}</span>}
            
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-xs" 
          />
          

        
    
        </DataTable></p>
        {openModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="fixed inset-0 bg-black opacity-5"></div>
        <div className="relative bg-white rounded-lg w-2/4 p-8 shadow-lg">
           
            <FirmSubUpdate />
           
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                <path d="M6.71 6.71a1 1 0 0 1 1.42 0L12 10.59l3.88-3.88a1 1 0 0 1 1.42 1.42L13.41 12l3.89 3.88a1 1 0 1 1-1.42 1.42L12 13.41l-3.88 3.89a1 1 0 0 1-1.42-1.42L10.59 12 6.71 8.12a1 1 0 0 1 0-1.41z" />
              </svg>
            </button>
          </div>
        </div>
      )}
   </div>
 
    </div>
       
 
 
);
};

export default FirmDtl;
